import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, Renderer2, ViewContainerRef } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { WindowComponent } from "sharedFeatures/window";
import { StartTrialWinBodyComponent } from './start-trial-win-body.component';

@Component({
    selector: 'start-trial-win',
    templateUrl: '../window/window.component.html',
    styleUrls: ['../window/window.component.less']
})
export class StartTrialWin extends WindowComponent implements OnDestroy, AfterViewInit {

    resizeObservable$ = fromEvent(window, 'resize');
    resizeSubscription$?: Subscription;
    selectedCompanyId: number = 0;

    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef,
        private ngZone: NgZone
    ) {

        super(element, r, viewContainerRef, chDet);

        this.width = -1;
        this.height = -1;

        this.showClose = false;

        this.title = '';

        this.cornerRadius = 0;

        this.isModal = true;

        this.topMargin = 20;

        this.windowContentBody = StartTrialWinBodyComponent;
    }

    getBodyComponent(): StartTrialWinBodyComponent {

        return <StartTrialWinBodyComponent>super.getBodyComponent();

    }

    ngAfterViewInit() {
        this.ngZone.runOutsideAngular(() => {
            this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
                const target = evt.target as Window;
                this.setSize(target.innerWidth, target.innerHeight);
            });
        });
        super.ngAfterViewInit();
    }

    ngOnDestroy() {
        this.resizeSubscription$?.unsubscribe();
    }
}
